import { createFileRoute, Outlet } from '@tanstack/react-router'
import { IdentityShell } from '@/components/identities/identity-shell'
import { PanelsSkeleton, ViewBarSkeleton } from '@/components/shell/screen-skeletons'
import { requireAnalyticsAccess } from '@/lib/queries/analytics-access'

/** The layout: ViewBar + DetailFrame; the tabs render into the Outlet. */
export const Route = createFileRoute('/o/$org/identities/$id')({
  /* Guards every identity sub-route (index, engagement, forms, people,
     identity) — beforeLoad on the layout runs before any child. */
  beforeLoad: ({ context: { queryClient }, params: { org } }) =>
    requireAnalyticsAccess({ queryClient, orgSlug: org }),
  pendingComponent: () => (
    <>
      <ViewBarSkeleton />
      <PanelsSkeleton panels={3} />
    </>
  ),
  component: IdentityLayout,
})

function IdentityLayout() {
  const { id } = Route.useParams()
  return (
    <IdentityShell identityId={id}>
      <Outlet />
    </IdentityShell>
  )
}
